// Centralized helpers for environment-aware URLs
// - In development: keep relative paths so CRA proxy can forward to the backend
// - In production: prepend the production domain unless an absolute URL is already provided

export const getApiBase = () => {
  // Highest priority: explicit override
  const envBase = process.env.REACT_APP_API_BASE;
  if (envBase && typeof envBase === 'string') {
    return envBase.replace(/\/$/, '');
  }

  const deployEnv = (process.env.REACT_APP_DEPLOY_ENV || '').toLowerCase();
  if (deployEnv === 'prod' && process.env.REACT_APP_API_BASE_PROD) {
    return process.env.REACT_APP_API_BASE_PROD.replace(/\/$/, '');
  }
  if (deployEnv === 'dev' && process.env.REACT_APP_API_BASE_DEV) {
    return process.env.REACT_APP_API_BASE_DEV.replace(/\/$/, '');
  }

  // Default to same-origin for both dev and prod.
  // - Dev: CRA proxy can route /api to backend
  // - Prod: Nginx (or reverse proxy) should route /api to backend
  return '';
};

export const buildMediaUrl = (candidate) => {
  if (!candidate || typeof candidate !== 'string') return '';
  if (candidate.startsWith('http://') || candidate.startsWith('https://')) return candidate;

  const base = getApiBase();
  let path = candidate.trim();
  if (path.startsWith('media/')) path = `/${path}`;
  // ensure single leading slash
  path = `/${path.replace(/^\/+/, '')}`;

  // If base is empty (dev), return relative path so proxy works
  if (!base) return path;

  return `${base}${path}`;
};
